import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Box, Container, Grid, Typography } from '@mui/material';
import TicketDetailsMessage from './TicketDetailsMessage';
import TicketDetailsNewMessage from './TicketDetailsNewMessage';

import { getCurrentTicket } from '../../../../actions/ticketsActions';
import { resetTicketsState } from '../../../../slices/ticketsSlice';

const styles = {
  title: {
    marginBottom: '1rem'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1'
  }
}

const TicketDetails = () => {
  const messagesContainer = useRef();

  const params = useParams();

  const dispatch = useDispatch();

  const current = useSelector(state => state.tickets.current);

  const scrollToBottom = () => {
    messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight;
  }

  useEffect(() => {
    dispatch(getCurrentTicket({ id: params.id, callback: scrollToBottom }));
    return () => dispatch(resetTicketsState())
  }, []);

  return (
    <>
      <Helmet>
        <title>Cristopher | Ticket {current.subject ?? ''}</title>
      </Helmet>
      <Box sx={styles.box}>
        <Container ref={messagesContainer} sx={{ flex: 1, overflowY: 'scroll', maxHeight: { xs: '70vh', md: '75vh' } }}>
          <Typography variant="h5" sx={styles.title} fontWeight="bold">Ticket: {current.subject ?? params.id}</Typography>
          <Grid container>
            {current.messages?.map?.(message =>
              <TicketDetailsMessage key={message._id} {...message} username={current.userRef?.name} />
            )}
          </Grid>
        </Container>
      </Box>
      <TicketDetailsNewMessage scrollCallback={scrollToBottom} />
    </>
  );
}

export default TicketDetails;
